var _use, _symbol;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJamfIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 65 65",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jamf-icon-A",
    x: 0.5,
    y: 0.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "jamf-icon-A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5.01A3.52 3.52 0 0 0 0 3.51v24.268c0 1.92 1.58 3.386 3.386 3.386h12.2c5.53 0 13.206-1.13 15.35-11.062L34.322 4.3c.452-2.145-1.242-4.3-3.5-4.3zm46.73 11.514c-8.24 0-13.093 3.5-15.35 10.95l-5.757 17.72c-2.145 5.87-5.53 8.24-11.626 8.24H3.273C1.467 48.434 0 49.901 0 51.707v9.03c0 1.693 1.354 3.16 3.16 3.16h57.566c1.806 0 3.273-1.467 3.273-3.273v-45.94c0-1.693-1.354-3.16-3.16-3.16z",
    stroke: "none",
    fill: "#778eb1",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJamfIcon);
export default __webpack_public_path__ + "static/media/jamf-icon.3b93bc25.svg";
export { ForwardRef as ReactComponent };